import React from 'react';
import { MARK_SRC, WORDMARK_SRC, MaskedArt } from './Logo';

/** Large footer lockup: official icon + wordmark, stretched across the content width. */
export function FooterWordmark() {
  return <div role="img" aria-label="Kays&Kays" className="flex w-full items-center gap-[2.5%]" data-id="element-189" data-mp="3lc1m2n350ot7">
      <MaskedArt src={MARK_SRC} className="aspect-square w-[17%]" data-id="element-190" data-mp="3gbvzvmfmzuii" />
      <MaskedArt src={WORDMARK_SRC} className="aspect-[1920/492] min-w-0 flex-1" data-id="element-191" data-mp="3gerx18jnuf5w" />
    </div>;
}